import { withDefaults } from 'react-bem-helper';

export const BEMHelper = withDefaults({
  outputIsString: true,
});

export const getClassesForCssModule = (baseClassName: string, styles: any) => {
  const BEMHelperInstance = new BEMHelper({
    name: baseClassName,
  });
  return (className?: string) => styles[BEMHelperInstance(className)];
};
